import type { FaireProductEntity } from "../../entity_types/product";

export const p_dqwcbnyrdt: FaireProductEntity = {
  token: "p_dqwcbnyrdt",
  type: "product",
  name: "Gradient Berry Mood Powder 10C Stick Packs",
  brandToken: "b_drpw6ajrkv",
  brandName: "Recess",
  imageUrl:
    "https://cdn.faire.com/fastly/96e01a3a360f46918b27e2126dea7a9c1e9c509c96e7f093a7413ff235454221.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cd08d3124a5a71305cb910a27f7a4a45fc2509b41843a55490c68db8d3f2818e.png",
    "https://cdn.faire.com/fastly/34b5a7c7faf2b4fc13fcfdc15c6aeb02b4188c1fefdd0d22a4c41da6380599df.png",
    "https://cdn.faire.com/fastly/faffea876a7f7e9914aa6bdbcdb3e7afb27e2e9fbb8576d8a372538ef4f3e928.png",
  ],
  priceDollars: 13.3,
  description:
    "A 3-in-1 powder blend with magnesium, adaptogens & electrolytes to calm the mind & brighten the day. 10 Sticks per box.",
  tags: [],
  msrpDollars: 21.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:49.441Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
